import ApiClient from '../ApiClient';

class WgptBotSourcesAPI extends ApiClient {
  constructor(botId) {
    super(`bots/${botId}/sources`, { accountScoped: true, wgpt: true });
  }
}

export default WgptBotSourcesAPI;
